import { render, staticRenderFns } from "./vaccines.vue?vue&type=template&id=053fc5d2&scoped=true&"
import script from "./vaccines.vue?vue&type=script&lang=js&"
export * from "./vaccines.vue?vue&type=script&lang=js&"
import style0 from "./vaccines.vue?vue&type=style&index=0&id=053fc5d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053fc5d2",
  null
  
)

export default component.exports